define('drops/calendarDayView/calendarDayView',[
    'jquery',
    'underscore',
    'moment',
    'lq/constants',
    'globalize',
    'lq/drop',
    'drops/calendar/calendarParameter',
    'drops/calendar/calendarItems',
    'lq/nestingContext',
    'tpl!drops/calendarDayView/calendarDayView.html',
    'lq/onlongpress'
], function ($, _, moment, constants, globalize, Drop, calendarParameter, calendarItems, NestingContext, template, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            dataSource: null,
            dataSourceType: 'datetimes',
            dateOutput: null,
            startOutput: null,
            endOutput: null,
            calendarStartParameter: 'CalendarDayStart',
            calendarEndParameter: 'CalendarDayEnd',
            timeslotSize: 30,
            dayStart: 0,
            dayEnd: (60 * 24) - 1,
            titleFormat: 'D',
            timeslotHourFormat: 'HH:mm',
            longPressDelay: 1000
        },
        childDrops: [
            {
                data: { type: 'CalendarItem' }
            }
        ]
    };

    function CalendarDayView(options) {
        Drop.call(this, $(template()), defaults, options);
        // right now we're not really doing anything with the selected date in the day view
        this.selectedDate = null;
    };

    Drop.extend(CalendarDayView, Drop);

    CalendarDayView.typeName = 'CalendarDayView';

    CalendarDayView.prototype.applyPosition = $.noop;

    CalendarDayView.prototype.init = function () {
        this.nestingContext = new NestingContext(this.piping);
        this.goToDefaultPosition();
    };

    CalendarDayView.prototype.goToDefaultPosition = function () {
        if (!$.isNumeric(this.data.defaultScrollPosition)) return;

        var slotNumber = Math.floor((this.data.defaultScrollPosition - this.data.dayStart) / this.data.timeslotSize);
        var $slot = this.$hours.children('.timeslot').eq(slotNumber);
        this.$container.scrollTop(this.$container.scrollTop() + $slot.position().top);
    };

    CalendarDayView.prototype.loadCalendarData = function () {
        if (!this.data.dataSource)
            return;

        var dateOfRequestedData = moment(this.date);

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (response) {
                if (dateOfRequestedData.isSame(self.date))
                    self.showItems(response.Outputs, response.Results);
            });
    };

    CalendarDayView.prototype.setSelectedDate = function (date) {
        this.selectedDate = date;
    };

    CalendarDayView.prototype.clearSelectedDate = function () {
        this.selectedDate = null;
    };

    CalendarDayView.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    CalendarDayView.prototype.render = function () {
        this.registerForDataSource();
        this.prepareUi();
        this.createTimeslots();
        this.open(moment());
    };

    CalendarDayView.prototype.prepareUi = function () {
        this.$container = this.$element.find('.calendar-main');
        this.$title = this.$element.find('.date-as-title');
        this.$hours = this.$element.find('.hours');
        this.$timeslots = this.$element.find('.timeslots');

        this.$element.find('.previous-page')
            .on('click', this.previous.bind(this));
        this.$element.find('.next-page')
            .on('click', this.next.bind(this));
    };

    CalendarDayView.prototype.createTimeslots = function () {
        var timeslots = _.range(this.data.dayStart, this.data.dayEnd, this.data.timeslotSize);

        var self = this;
        var $hours = _.map(timeslots, function (slot) {
            var date = new Date(1970, 0, 1);
            date.setMinutes(slot);

            return $('<div />')
                .addClass('timeslot')
                .append($('<span />')
                    .text(globalize.format(date, self.data.timeslotHourFormat)));
        });
        this.$hours.append($hours);

        var $timeslots = _.map(timeslots, function (startMinute) {
            var $timeslot = $('<div />')
                .addClass('timeslot');

            if (!self.designData && self.isEventEnabled('onLongPress')) {
                OnLongPress.applyLongPressOnElement($timeslot, self,
                    function(e) {
                        return self.determineEventArg(startMinute);
                    });
            } else if (self.isEventEnabled('clicked')) {
                $timeslot.on('click', function () {
                    self.timeslotClicked(startMinute);
                });
            }

            $timeslot.on("mousedown", calendarItems.timeslotMousedown.bind(self, self.$timeslots, 0));
            $timeslot.on("mouseup", calendarItems.timeslotMouseup.bind(self));
            $timeslot.on("mousemove", calendarItems.timeslotMousemove.bind(self));

            return $timeslot;
        });
        this.$timeslots.append($timeslots);

    };

    var round = function (x, roundTo) {
        return Math.round(x / roundTo) * roundTo;
    }

    var getMouseEventMinutes = function (e, data) {
        var timeslotIndex = $(e.target).index();
        var y = e.offsetY;
        var yTot = timeslotIndex * data.timeslotSize + y;

        var creationInterval = data.creationInterval || data.timeslotSize; // creationInterval editable in property editor?
        return round(yTot, creationInterval);
    }

    CalendarDayView.prototype.determineEventArg = function (startMinute) {
        var dateAndTime = moment(this.date)
            .startOf('day')
            .add(startMinute, 'minute');
        return globalize.format(dateAndTime.toDate(), constants.licquidDateFormat);
    };

    CalendarDayView.prototype.timeslotClicked = function (startMinute) {
        var eventArg = this.determineEventArg(startMinute);
        this.triggerEvent(this.data.eventing.clicked.raisedEventName, eventArg);
    };

    CalendarDayView.prototype.registerForDataSource = function () {
        if (this.data.dataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                self.removeCalendarItems();
                self.showItems(data.Outputs, data.Results);
            });
        }
    };

    CalendarDayView.prototype.previous = function () {
        this.open(moment(this.date).add(-1, 'day'));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarDayView.prototype.next = function () {
        this.open(moment(this.date).add(1, 'day'));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarDayView.prototype.triggerNavigatedEvent = function () {
        this.triggerEventIfEnabled('navigated', this.date);
    };

    CalendarDayView.prototype.open = function (date) {
        this.date = date;
        this.updateTitle();
        this.removeCalendarItems();

        var parameters = this.piping.parameters;
        parameters.locals.setValue(this.data.calendarStartParameter, calendarParameter.convert(moment(this.date).startOf('day')));
        parameters.locals.setValue(this.data.calendarEndParameter, calendarParameter.convert(moment(this.date).endOf('day')));
    };

    CalendarDayView.prototype.getOpenDate = function () {
        return this.date;
    };

    CalendarDayView.prototype.updateTitle = function () {
        var title = globalize.format(this.date.toDate(), this.data.titleFormat);
        this.$title.text(title);
    };

    CalendarDayView.prototype.showItems = function (outputs, rows) {
        var startOfDay = moment(this.date).startOf('day').add(this.data.dayStart, 'minutes');
        var endOfDay = moment(this.date).startOf('day').add(this.data.dayEnd, 'minutes');

        var self = this;
        var items = _.map(rows, function (row) {
            var startOfItem = self.getDatetimeFromRow(row, self.data.startOutput);
            var endOfItem = self.getDatetimeFromRow(row, self.data.endOutput);

            return $.extend(true, {}, self.childDrops[0],{
                data: {
                    $target: self.$timeslots,
                    startOfDay: startOfDay,
                    endOfDay: endOfDay,
                    startOfItem: startOfItem,
                    endOfItem: endOfItem,
                    row: row,
                    outputs: outputs,
                    eventArg: self.data.eventArg,
                    tooltipOutput: self.data.tooltipOutput,
                    idOutput: self.data.idOutput
                }
            });
        });

        calendarItems.fillUp(this, items)
            .then(function () {
                self.nestingContext.executeDataSources();
            });
    };

    CalendarDayView.prototype.removeCalendarItems = function () {
        _.each(this.pool, function (drop) {
            drop.$element.remove();
        });
        this.removeAllDrops();
    };

    CalendarDayView.prototype.getDatetimeFromRow = function (row, output) {
        if (this.data.dataSourceType === 'datetimes')
            return moment(row[output]);

        var date = moment(this.date).startOf('day');
        var time = row[output];
        return date.add(time, 'seconds');
    };

    return CalendarDayView;
});
